/* global angular */

angular.module('AemCspsDpsChildren')
  .controller('AemCspsDpsChildrenCtrl', AemCspsDpsChildrenCtrl)

require('./inlet.css')
var subYears = require('date-fns/fp/subYears').default
var startOfDay = require('date-fns/fp/startOfDay').default
var parseISO = require('date-fns/fp/parseISO').default
var differenceInYears = require('date-fns/fp/differenceInYears').default
var differenceInMonths = require('date-fns/fp/differenceInMonths').default
var addDays = require('date-fns/fp/addDays').default
var isMobile = require('aem-libs/src/isMobile')
var Highcharts = require('highcharts')
var highcharts3d = require('highcharts/highcharts-3d')
highcharts3d(Highcharts)
require('./services/generator.dataservice')

AemCspsDpsChildrenCtrl.$inject = ['appLoader', 'widgetParamsService', 'generatorDataservice', 'pensionSavingsPlanService', 'userTracking', '$timeout', '$filter',
  'pensionCpsService', '$location', 'wgService']

function AemCspsDpsChildrenCtrl (appLoader, widgetParamsService, generatorDataservice, pensionSavingsPlanService, userTracking, $timeout, $filter, pensionCpsService,
  $location, wgService) {
  var vm = this
  var canceler = null
  var pensionAmountBaseUrl = null

  vm.$onInit = function () {
    vm.submit = submit
    vm.isErrorBackend = false
    vm.onErrorOccured = onErrorOccured
    vm.onBirthDateChanged = onBirthDateChanged
    vm.calculatePension = calculatePension
    vm.showSavingsDetail = false
    vm.partialPension = false
    vm.showDetail = false
    vm.getPensionAmountUrl = getPensionAmountUrl
    vm.result = null
    vm.ageYears = null
    vm.ageMonths = null
    vm.cpsExportButton = wgService.getParams().cpsExport
    vm.cpsSendHandler = cpsSendHandler
    vm.isMobile = isMobile
    vm.showCpsSending = false
    vm.showCpsSent = false
    vm.showCpsSentError = false
    vm.getParameterByName = getParameterByName

    widgetParamsService.get('AemCspsDpsChildren')
      .then(function (res) {
        pensionAmountBaseUrl = res.data.dpsPensionAmountBaseUrl
        vm.birthDate = {
          min: addDays(1)(startOfDay(subYears(18)(Date.now()))),
          max: startOfDay(Date.now()),
          default: parseISO('2017-01-01')
        }
        try {
          vm.birthDate = {
            min: parseISO(res.data.params.birthDate.min),
            max: startOfDay(Date.now()),
            default: parseISO(res.data.params.birthDate.default)
          }
        } catch (e) {}
        vm.birthDate.value = vm.birthDate.default
        vm.ageYears = differenceInYears(vm.birthDate.value, Date.now())
        vm.ageMonths = differenceInMonths(vm.birthDate.value, Date.now()) % 12
        vm.calculationType = generatorDataservice.value('calculationType', res.data.params, { default: 'MAJORITY' })
        vm.gender = generatorDataservice.value('gender', res.data.params, { default: 'F' })
        vm.participantMonthlyContribution = generatorDataservice.value('participantMonthlyContribution', res.data.params, { min: 0, max: 100000, default: 1000, step: 10 })
        vm.employerMonthlyContribution = generatorDataservice.value('employerMonthlyContribution', res.data.params, { min: 0, max: 100000, default: 1000, step: 10 })
        vm.initialDeposit = generatorDataservice.value('initialDeposit', res.data.params, { min: 0, max: 100000, default: 100000, step: 10 })
        vm.partyContributionSum = generatorDataservice.value('partyContributionSum', res.data.params, { min: 0, max: 10000000, default: 0, step: 1000 })
        vm.employerContributionSum = generatorDataservice.value('employerContributionSum', res.data.params, { min: 0, max: 10000000, default: 0, step: 1000 })
        vm.stateContributionSum = generatorDataservice.value('stateContributionSum', res.data.params, { min: 0, max: 10000000, default: 0, step: 1000 })
        vm.yieldSum = generatorDataservice.value('yieldSum', res.data.params, { min: 0, max: 10000000, default: 0, step: 1000 })
        vm.totalSavedAmount = {
          min: Math.max(vm.partyContributionSum.min, vm.employerContributionSum.min, vm.stateContributionSum.min, vm.yieldSum.min),
          max: Math.min(vm.partyContributionSum.max, vm.employerContributionSum.max, vm.stateContributionSum.max, vm.yieldSum.max),
          default: vm.partyContributionSum.default + vm.employerContributionSum.default + vm.stateContributionSum.value + vm.yieldSum.default,
          value: vm.partyContributionSum.value + vm.employerContributionSum.value + vm.stateContributionSum.value + vm.yieldSum.value,
          step: Math.min(vm.partyContributionSum.step, vm.employerContributionSum.step, vm.stateContributionSum.step, vm.yieldSum.step)
        }
        vm.conservativeFund = generatorDataservice.value('conservativeFund', res.data.params, { min: 0, max: 100, default: 0, step: 1 })
        vm.balancedFund = generatorDataservice.value('balancedFund', res.data.params, { min: 0, max: 100, default: 100, step: 1 })
        vm.dynamicFund = generatorDataservice.value('dynamicFund', res.data.params, { min: 0, max: 100, default: 0, step: 1 })
        vm.eaFund = generatorDataservice.value('eaFund', res.data.params, { min: 0, max: 100, default: 0, step: 1 })
        vm.partialPension = !(differenceInYears(vm.birthDate.value, Date.now()) > 7)
        vm.adult = differenceInYears(vm.birthDate.value, Date.now()) > 17
        vm.savingsIn = 'PENSION'
        vm.fundsStrategyPercent = vm.conservativeFund.value + vm.balancedFund.value + vm.dynamicFund.value + vm.eaFund.value
        vm.fundsStrategyValid = (vm.fundsStrategyPercent === 100)
        vm.showSavingsDetail = vm.employerContributionSum.default > 0 || vm.stateContributionSum.default > 0 || vm.yieldSum.default > 0

        // set params from URL
        if (getParameterByName('dayOfBirth') || getParameterByName('monthOfBirth') || getParameterByName('yearOfBirth')) {
          var defaultBirthDate
          var year = (getParameterByName('yearOfBirth') && getParameterByName('yearOfBirth') > vm.birthDate.min.getFullYear() && getParameterByName('yearOfBirth') < (new Date(vm.birthDate.max)).getFullYear())
            ? getParameterByName('yearOfBirth')
            : vm.birthDate.default.getFullYear()
          var month = getParameterByName('monthOfBirth') && getParameterByName('monthOfBirth') >= 1 && getParameterByName('monthOfBirth') <= 12
            ? getParameterByName('monthOfBirth')
            : vm.birthDate.default.getMonth() + 1
          var day = getParameterByName('dayOfBirth') ? getParameterByName('dayOfBirth') : vm.birthDate.default.getDate()
          if ((month + '').length < 2) {
            month = '0' + month
          }
          if ((day + '').length < 2) {
            day = '0' + day
          }
          defaultBirthDate = year + '-' + month + '-' + day
          vm.birthDate.value = parseISO(defaultBirthDate) + '' === 'Invalid Date' ? vm.birthDate.default : parseISO(defaultBirthDate)
        }
        if (getParameterByName('gender') && (getParameterByName('gender') === 'F' || getParameterByName('gender') === 'M')) {
          vm.gender.value = getParameterByName('gender')
        }
        if (getParameterByName('participantMonthlyContribution') &&
        parseInt(getParameterByName('participantMonthlyContribution')) > vm.participantMonthlyContribution.min &&
        parseInt(getParameterByName('participantMonthlyContribution')) < vm.participantMonthlyContribution.max) {
          vm.participantMonthlyContribution.value = parseInt(getParameterByName('participantMonthlyContribution')) ? parseInt(getParameterByName('participantMonthlyContribution')) : vm.participantMonthlyContribution.value
        }
        if (getParameterByName('employerMonthlyContribution') &&
            parseInt(getParameterByName('employerMonthlyContribution')) > vm.employerMonthlyContribution.min &&
            parseInt(getParameterByName('employerMonthlyContribution')) < vm.employerMonthlyContribution.max) {
          vm.employerMonthlyContribution.value = parseInt(getParameterByName('employerMonthlyContribution')) ? parseInt(getParameterByName('employerMonthlyContribution')) : vm.employerMonthlyContribution.value
        }
        if (getParameterByName('initialDeposit') &&
        parseInt(getParameterByName('initialDeposit')) > vm.initialDeposit.min &&
        parseInt(getParameterByName('initialDeposit')) < vm.initialDeposit.max) {
          vm.initialDeposit.value = parseInt(getParameterByName('initialDeposit')) ? parseInt(getParameterByName('initialDeposit')) : vm.initialDeposit.value
        }
        if (getParameterByName('partyContributionSum') &&
        parseInt(getParameterByName('partyContributionSum')) > vm.partyContributionSum.min &&
        parseInt(getParameterByName('partyContributionSum')) < vm.partyContributionSum.max) {
          vm.showSavingsDetail = true
          vm.partyContributionSum.value = parseInt(getParameterByName('partyContributionSum')) ? parseInt(getParameterByName('partyContributionSum')) : vm.partyContributionSum.value
        }
        if (getParameterByName('employerContributionSum') &&
        parseInt(getParameterByName('employerContributionSum')) > vm.employerContributionSum.min &&
        parseInt(getParameterByName('employerContributionSum')) < vm.employerContributionSum.max) {
          vm.showSavingsDetail = true
          vm.employerContributionSum.value = parseInt(getParameterByName('employerContributionSum')) ? parseInt(getParameterByName('employerContributionSum')) : vm.employerContributionSum.value
        }
        if (getParameterByName('stateContributionSum') &&
        parseInt(getParameterByName('stateContributionSum')) > vm.stateContributionSum.min &&
        parseInt(getParameterByName('stateContributionSum')) < vm.stateContributionSum.max) {
          vm.showSavingsDetail = true
          vm.stateContributionSum.value = parseInt(getParameterByName('stateContributionSum')) ? parseInt(getParameterByName('stateContributionSum')) : vm.stateContributionSum.value
        }
        if (getParameterByName('yieldSum') &&
        parseInt(getParameterByName('yieldSum')) > vm.yieldSum.min &&
        parseInt(getParameterByName('yieldSum')) < vm.yieldSum.max) {
          vm.showSavingsDetail = true
          vm.yieldSum.value = parseInt(getParameterByName('yieldSum')) ? parseInt(getParameterByName('yieldSum')) : vm.yieldSum.value
        }
        if (getParameterByName('totalSavedAmount') &&
        parseInt(getParameterByName('totalSavedAmount')) > vm.totalSavedAmount.min &&
        parseInt(getParameterByName('totalSavedAmount')) < vm.totalSavedAmount.max) {
          vm.showSavingsDetail = false
          vm.totalSavedAmount.value = parseInt(getParameterByName('totalSavedAmount')) ? parseInt(getParameterByName('totalSavedAmount')) : vm.totalSavedAmount.value
        }
        if (getParameterByName('conservativeFund')) {
          vm.conservativeFund.value = (parseInt(getParameterByName('conservativeFund')) >= 0) ? parseInt(getParameterByName('conservativeFund')) : vm.conservativeFund.value
        }
        if (getParameterByName('balancedFund')) {
          vm.balancedFund.value = (parseInt(getParameterByName('balancedFund')) >= 0) ? parseInt(getParameterByName('balancedFund')) : vm.balancedFund.value
        }
        if (getParameterByName('dynamicFund')) {
          vm.dynamicFund.value = (parseInt(getParameterByName('dynamicFund')) >= 0) ? parseInt(getParameterByName('dynamicFund')) : vm.dynamicFund.value
        }
        if (getParameterByName('eaFund')) {
          vm.eaFund.value = (parseInt(getParameterByName('eaFund')) >= 0) ? parseInt(getParameterByName('eaFund')) : vm.eaFund.value
        }
        submit()
      })
      .catch(function () {
        vm.onErrorOccured()
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function onBirthDateChanged () {
    if (vm.birthDate.value === null) {
      vm.birthDate.value = vm.birthDate.default
    }
    if (vm.birthDate.value < vm.birthDate.min) {
      vm.birthDate.value = vm.birthDate.min
    }
    if (vm.birthDate.value > vm.birthDate.max) {
      vm.birthDate.value = vm.birthDate.max
    }
    vm.partialPension = !(differenceInYears(vm.birthDate.value, Date.now()) > 7)
    vm.adult = differenceInYears(vm.birthDate.value, Date.now()) > 17
    vm.ageYears = differenceInYears(vm.birthDate.value, Date.now())
    vm.ageMonths = differenceInMonths(vm.birthDate.value, Date.now()) % 12
    submit()
  }

  function getData () {
    return {
      calculationType: vm.calculationType.value,
      yearOfBirth: vm.birthDate.value.getFullYear(),
      monthOfBirth: vm.birthDate.value.getMonth() + 1,
      dayOfBirth: vm.birthDate.value.getDate(),
      gender: vm.gender.value,
      participantMonthlyContribution: vm.participantMonthlyContribution.value,
      employerMonthlyContribution: vm.employerMonthlyContribution.value,
      initialDeposit: vm.initialDeposit.value,
      currentSavings: {
        totalSavedAmount: vm.totalSavedAmount.value,
        partyContributionSum: vm.partyContributionSum.value,
        employerContributionSum: vm.employerContributionSum.value,
        stateContributionSum: vm.stateContributionSum.value,
        yieldSum: vm.yieldSum.value
      },
      fundStrategy: {
        conservativeFund: vm.conservativeFund.value,
        balancedFund: vm.balancedFund.value,
        dynamicFund: vm.dynamicFund.value,
        eaFund: vm.eaFund.value
      }
    }
  }

  function submit () {
    vm.fundsStrategyPercent = vm.conservativeFund.value + vm.balancedFund.value + vm.dynamicFund.value + vm.eaFund.value
    vm.fundsStrategyValid = (vm.fundsStrategyPercent === 100)
    if (!vm.fundsStrategyValid) {
      return
    }

    if (vm.showSavingsDetail) {
      vm.totalSavedAmount.value = vm.partyContributionSum.value + vm.employerContributionSum.value + vm.stateContributionSum.value + vm.yieldSum.value
    } else {
      vm.partyContributionSum.value = vm.totalSavedAmount.value
      vm.employerContributionSum.value = 0
      vm.stateContributionSum.value = 0
      vm.yieldSum.value = 0
    }

    var data = getData()

    if (canceler) {
      canceler.resolve()
    }
    userTracking.onRequest(data)
    var request = pensionSavingsPlanService.dps(data)
    canceler = request.canceler
    request.promise
      .then(function (res) {
        userTracking.onResponse(res.data)
        vm.result = res.data
        if (vm.result.majorityDay) {
          vm.result.majorityDate = vm.result.majorityDay + '.' + vm.result.majorityMonth + '.' + vm.result.majorityYear
        }
        $timeout(drawChart)
        calculatePension()
      })
      .catch(function (err) {
        if (~err.status) {
          userTracking.onResponse(null, 'failed')
          vm.onErrorOccured()
        }
      })
  }

  function calculatePension () {
    vm.fundsStrategyPercent = vm.conservativeFund.value + vm.balancedFund.value + vm.dynamicFund.value + vm.eaFund.value
    vm.fundsStrategyValid = (vm.fundsStrategyPercent === 100)
    if (!vm.fundsStrategyValid) {
      return
    }
    if (canceler) {
      canceler.resolve()
    }
    var data = getData()
    data.calculationType = vm.savingsIn
    var request = pensionSavingsPlanService.dps(data)
    canceler = request.canceler
    request.promise
      .then(function (res) {
        userTracking.onResponse(res.data)
        vm.result1 = res.data
      })
      .catch(function (err) {
        if (~err.status) {
          userTracking.onResponse(null, 'failed')
          vm.onErrorOccured()
        }
      })
  }

  function onErrorOccured (err) {
    if (err.status < 500) {
      vm.dataNotFound = true
    } else {
      vm.isErrorBackend = true
    }
  }

  function drawChart () {
    var data = []
    var y = 0
    if (vm.result.totalPartyContribution && vm.result.totalSavedAmount) {
      y = vm.result.totalPartyContribution / vm.result.totalSavedAmount
      data.push({
        name: $filter('translate')('CSPS_DPS_CHILDREN.RESULT.GRAPH_PARTY_CONTRIBUTION'),
        y: y > 0 ? y : 0,
        sliced: true,
        selected: true
      })
    }
    if (vm.result.totalEmployerContribution && vm.result.totalSavedAmount) {
      y = vm.result.totalEmployerContribution / vm.result.totalSavedAmount
      data.push({
        name: $filter('translate')('CSPS_DPS_CHILDREN.RESULT.GRAPH_EMPLOYER_CONTRIBUTION'),
        y: y > 0 ? y : 0,
        sliced: true
      })
    }
    if (vm.result.totalStateContribution && vm.result.totalSavedAmount) {
      y = vm.result.totalStateContribution / vm.result.totalSavedAmount
      data.push({
        name: $filter('translate')('CSPS_DPS_CHILDREN.RESULT.GRAPH_STATE_CONTRIBUTION'),
        y: y > 0 ? y : 0,
        sliced: true
      })
    }
    if (vm.result.totalExpectedYield && vm.result.totalSavedAmount) {
      y = vm.result.totalExpectedYield / vm.result.totalSavedAmount
      data.push({
        name: $filter('translate')('CSPS_DPS_CHILDREN.RESULT.GRAPH_EXPECTED_YIELD'),
        y: y > 0 ? y : 0,
        sliced: true
      })
    }

    Highcharts.setOptions({
      lang: {
        decimalPoint: ','
      }
    })
    Highcharts.chart('chartContainer', {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0
        }
      },
      title: {
        text: undefined
      },
      tooltip: {
        enabled: (isMobile()),
        pointFormat: (isMobile() ? '<b>{point.percentage:.1f}%</b>' : '')
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          depth: 35,
          dataLabels: {
            enabled: (!isMobile()),
            format: '{point.name} <b>{point.percentage:.1f} %</b>',
            style: { 'fontSize': '15px', 'fontWeight': 'normal', 'textOutline': '1px contrast' }
          },
          colors: pieColors(),
          showInLegend: (isMobile())
        }
      },
      credits: {
        enabled: false
      },
      series: [{
        type: 'pie',
        name: $filter('translate')('CSPS_DPS_CHILDREN.RESULT.TOTAL_SAVED_AMOUNT'),
        data: data
      }]
    })
  }

  function pieColors () {
    var colors = []
    var base = Highcharts.getOptions().colors[0]

    for (var i = 0; i < 10; i++) {
      // Start out with a darkened base color (negative brighten), and end
      // up with a much brighter color
      colors.push(Highcharts.Color(base).brighten((i - 3) / 7).get())
    }
    return colors
  }

  function getPensionAmountUrl () {
    if (pensionAmountBaseUrl) {
      return pensionAmountBaseUrl + '?' + [
        'totalSavedAmount=' + vm.result1.totalSavedAmount,
        'totalPartyContribution=' + vm.result1.totalPartyContribution,
        'totalEmployerContribution=' + vm.result1.totalEmployerContribution,
        'totalStateContribution=' + vm.result1.totalStateContribution,
        'totalExpectedYield=' + vm.result1.totalExpectedYield
      ].join('&')
    } else {
      return '/'
    }
  }

  // get parameter from url
  function getParameterByName (name) {
    var searchObject = $location.search()
    return searchObject[name]
  }

  function cpsSendHandler () {
    vm.showCpsSending = true
    var data = {
      participantMonthlyContribution: vm.participantMonthlyContribution.value,
      employerMonthlyContribution: vm.employerMonthlyContribution.value,
      partyContributionSum: vm.partyContributionSum.value,
      fundStrategy: {
        conservativeFund: vm.conservativeFund.value,
        balancedFund: vm.balancedFund.value,
        dynamicFund: vm.dynamicFund.value,
        eaFund: vm.eaFund.value
      }
    }
    var refId = ''
    if (getParameterByName('refId')) {
      refId = getParameterByName('refId')
    }
    if (canceler) {
      canceler.resolve()
    }
    var request = pensionCpsService.cpsExport(data, refId)
    canceler = request.canceler
    return request.promise
      .then(function (res) {
        userTracking.onResponse(res.data)
        vm.showCpsSending = false
        vm.showCpsSent = true
      })
      .catch(function (err) {
        vm.showCpsSending = false
        vm.showCpsSentError = true
        if (~err.status) {
          userTracking.onResponse(null, 'failed')
        }
      })
  }
}
